import React from 'react';
import { useParams } from 'react-router-dom';
import { PageHeader } from '../components/PageHeader';
import { AppointmentAside } from '../components/AppointmentAside';
import { TreatmentList } from '../components/TreatmentList';
import { NotFound } from './NotFound';
import { complaints } from '../data/complaints';
import { treatments } from '../data/treatments';
export function ComplaintDetail() {
  const {
    slug
  } = useParams();
  const complaint = complaints.find(c => c.slug === slug);
  if (!complaint) return <NotFound data-id="element-391" data-mp="1kee8hb880nd7" />;
  const related = complaint.treatmentSlugs.map(s => treatments.find(t => t.slug === s)).filter((t): t is NonNullable<typeof t> => Boolean(t));
  return <>
      <PageHeader title={complaint.title} crumbs={[{
      label: 'Pijnklachten',
      to: '/pijnbehandelingen'
    }, {
      label: complaint.title
    }]} data-id="element-392" data-mp="1ueokisiiroqs" />

      <div className="mx-auto grid max-w-7xl gap-12 px-5 py-14 lg:grid-cols-12 lg:gap-16 lg:px-8 lg:py-20" data-id="element-393" data-mp="3w500qaajtbmn">
        <div className="lg:col-span-8" data-id="element-394" data-mp="zbh5h8auqi6y">
          <img src={complaint.image} alt="" className="aspect-[16/7] w-full rounded-3xl object-cover" data-id="element-395" data-mp="zcidf3wkmokg" />
          <div className="mt-10 space-y-4 text-lg leading-relaxed text-muted" data-id="element-396" data-mp="14atp7k6ff95b">
            {complaint.description.map(p => <p key={p} data-id="element-397" data-mp="197k5a7i8e4qq">{p}</p>)}
          </div>

          <section className="mt-14" data-id="element-398" data-mp="1e0ve2e6lsvla">
            <h2 className="font-display text-2xl font-semibold text-ink" data-id="element-399" data-mp="1e1wt0tqqq28a">Behandelingen</h2>
            <p className="mt-2 text-[15px] text-muted" data-id="element-400" data-mp="1j19fhddp97ac">
              Tijdens de intake bepaalt de pijnspecialist samen met u welke behandeling bij u past.
            </p>
            <div className="mt-6" data-id="element-401" data-mp="1s0eai9q1yihr">
              <TreatmentList treatments={related} data-id="element-402" data-mp="1ry1rruch043n" />
            </div>
          </section>
        </div>

        <div className="lg:col-span-4" data-id="element-403" data-mp="3tr7uraazjnw3">
          <AppointmentAside data-id="element-404" data-mp="3ts9juiou6awt" />
        </div>
      </div>
    </>;
}